import { render, staticRenderFns } from "./AssessmentReferee.vue?vue&type=template&id=fde6c33e"
import script from "./AssessmentReferee.vue?vue&type=script&lang=js"
export * from "./AssessmentReferee.vue?vue&type=script&lang=js"
import style0 from "./AssessmentReferee.vue?vue&type=style&index=0&id=fde6c33e&prod&lang=css"
import style1 from "./AssessmentReferee.vue?vue&type=style&index=1&id=fde6c33e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports